import { Select } from '@mantine/core'
import { translate } from 'i18n/i18n'
import { memo } from 'react'
import { mantineSelectSearchFilterProp } from 'utils/mantineSelectSearchFilterProp'
import { useSelectClickToggle } from 'utils/useSelectClickToggle'
import { getStyles } from './getStyles'

const PropertySelectWithNoMemoization = ({
  clearable = true,
  data,
  disabled = false,
  onChange,
  selectedPropertyId,
  placeholder = translate.phrases.banyanApp('Select a Property'),
}: {
  clearable?: boolean
  data: { value: string; label: string; disabled?: boolean }[]
  disabled?: boolean
  onChange?: (propertyId: number | null) => void
  selectedPropertyId: number | null
  placeholder?: string
}) => {
  const selectClickToggle = useSelectClickToggle()

  return (
    <Select
      {...selectClickToggle}
      css={{ borderRadius: 3 }}
      clearable={clearable}
      data={data}
      disabled={disabled}
      filter={mantineSelectSearchFilterProp}
      onChange={
        onChange
          ? (propertyId) => {
              onChange(propertyId === null ? null : Number(propertyId))
            }
          : undefined
      }
      searchable
      size="sm"
      spellCheck="false"
      placeholder={placeholder}
      styles={getStyles(clearable, disabled)}
      value={selectedPropertyId === null ? null : String(selectedPropertyId)}
    />
  )
}

export const PropertySelect = memo(PropertySelectWithNoMemoization)
